
























import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class Group extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: {
      partnerCount: 0,
      limitCount: 0,
      expriedTime: 0,
      isUseVirtualUser: true,
      deal: 0,
      description: '',
      memberScope: 'All',
      cumulativeWithOtherDiscount: false
    }
  })
  value!: any
}
